import type { WJobOffersTranslations } from "./pl";

export const de: WJobOffersTranslations = {
  apply: "Bewerben",
  sendCv: "Lebenslauf senden",
};
